// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2fAS5","tab":"ProcedureTabs_tab__2fkHQ"};